export const DEFAULT_RECORD: any = null;
